export let scrollValue = 0
export let scrollValueExpo = 0

let target = 0

interface ScrollOptions {
    max: number
    min?: number
    init: number
}

const defaultOptions: ScrollOptions = {
    max: 0,
    init: 0
}

export function initScrollListener(userOptions?: Partial<ScrollOptions>) {
    const opts: ScrollOptions = {
        ...defaultOptions,
        ...userOptions
    }

    target = opts.init
    scrollValue = target

    document.addEventListener("wheel", (event: WheelEvent) => {
        target += event.deltaY
        if (target > opts.max) target = opts.max
        if (opts.min != undefined && target < opts.min) target = opts.min
        console.log(target)
    })

    requestAnimationFrame(interpolate)
}

function interpolate() {
    const diff = target - scrollValue
    scrollValue += diff * 0.1
    scrollValueExpo = Math.pow(2, -scrollValue / 1000)
    requestAnimationFrame(interpolate)
}